import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

export default function Login() {
  const [identifier, setIdentifier]       = useState('');
  const [password, setPassword]           = useState('');
  const [showPassword, setShowPassword]   = useState(false);
  const [error, setError]                 = useState('');
  const [loading, setLoading]             = useState(false);
  const [modoRecuperar, setModoRecuperar] = useState(false);
  const [emailRecuperar, setEmailRecuperar] = useState('');
  const [msgRecuperar, setMsgRecuperar]   = useState('');

  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email: identifier, password });
      login(res.data.token, res.data.tecnico);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleRecuperar = async (e) => {
    e.preventDefault();
    setMsgRecuperar('');
    setLoading(true);
    try {
      await api.post('/auth/recuperar', { email: emailRecuperar });
      setMsgRecuperar('Si el correo existe, recibirás instrucciones en tu bandeja.');
    } catch {
      setMsgRecuperar('Error al enviar. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '12px 14px',
    border: '1.5px solid #2E4A40', borderRadius: 10,
    fontSize: 15, background: '#0D1311', color: '#F4F7F5',
    fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none',
  };

  const labelStyle = {
    display: 'block', fontSize: 12, fontWeight: 600, color: '#9FAAA5',
    marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #0a5c47 0%, #0f6e56 50%, #1d9e75 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '24px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    }}>

      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <div style={{
          width: 110, height: 110, background: 'white', borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px', boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
          overflow: 'hidden', padding: 8,
        }}>
          <img src="/logo_solvert.jpg" alt="Solvert"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
        <h1 style={{ color: 'white', margin: 0, fontSize: 28, fontWeight: 800 }}>Solvert App</h1>
        <p style={{ color: 'rgba(255,255,255,0.85)', margin: '6px 0 0', fontSize: 13 }}>Mantención de Ascensores</p>
        <p style={{ color: 'rgba(255,255,255,0.65)', margin: '4px 0 0', fontSize: 12 }}>ROL MINVU N°294</p>
      </div>

      <div style={{
        background: '#111714', borderRadius: 20, padding: '28px 24px 24px',
        width: '100%', maxWidth: 360,
        border: '1px solid #24312B',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        {!modoRecuperar ? (
          <>
            <h2 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: '#F4F7F5' }}>Iniciar sesión</h2>
            <p style={{ margin: '0 0 20px', fontSize: 13, color: '#9FAAA5' }}>Ingresa tus credenciales para continuar</p>

            {error && (
              <div style={{ background: '#2D0F0F', color: '#EF4444', padding: '10px 14px',
                borderRadius: 10, fontSize: 13, marginBottom: 16, borderLeft: '4px solid #c62828' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Correo o usuario</label>
                <input
                  type="text"
                  value={identifier}
                  onChange={e => setIdentifier(e.target.value)}
                  placeholder="correo@ejemplo.com o usuario"
                  autoComplete="username"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Contraseña</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="••••••••"
                    autoComplete="current-password"
                    required
                    style={{ ...inputStyle, paddingRight: 44 }}
                  />
                  <button type="button" onClick={() => setShowPassword(!showPassword)}
                    style={{ position: 'absolute', right: 12, top: '50%',
                      transform: 'translateY(-50%)', background: 'none',
                      border: 'none', cursor: 'pointer', color: '#6B7C74',
                      padding: '4px', display: 'flex', alignItems: 'center' }}>
                    {showPassword
                      ? <EyeOff size={17} strokeWidth={1.75} />
                      : <Eye size={17} strokeWidth={1.75} />
                    }
                  </button>
                </div>
              </div>

              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '14px',
                background: loading ? '#2A332F' : '#0F6E56',
                color: 'white', border: 'none', borderRadius: 12,
                fontSize: 16, fontWeight: 700, cursor: 'pointer',
              }}>
                {loading ? 'Ingresando...' : 'Ingresar'}
              </button>
            </form>

            <button onClick={() => setModoRecuperar(true)} style={{
              background: 'none', border: 'none', color: '#0f6e56',
              fontSize: 13, cursor: 'pointer', marginTop: 16,
              width: '100%', textAlign: 'center',
            }}>
              ¿Olvidaste tu contraseña?
            </button>
          </>
        ) : (
          <>
            <h2 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: '#F4F7F5' }}>Recuperar contraseña</h2>
            <p style={{ margin: '0 0 20px', fontSize: 13, color: '#9FAAA5' }}>Ingresa tu correo para recibir instrucciones</p>

            {msgRecuperar && (
              <div style={{ background: '#12382D', color: '#4CAF50', padding: '10px 14px',
                borderRadius: 10, fontSize: 13, marginBottom: 16, borderLeft: '4px solid #0F6E56' }}>
                {msgRecuperar}
              </div>
            )}

            <form onSubmit={handleRecuperar} style={{ width: '100%' }}>
              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Correo electrónico</label>
                <input
                  type="email"
                  value={emailRecuperar}
                  onChange={e => setEmailRecuperar(e.target.value)}
                  placeholder="tu@solvert.cl"
                  autoComplete="email"
                  required
                  style={inputStyle}
                />
              </div>
              <button type="submit" disabled={loading} style={{
                display: 'block', width: '100%', padding: '14px',
                background: loading ? '#2A332F' : '#0F6E56',
                color: 'white', border: 'none', borderRadius: 12,
                fontSize: 16, fontWeight: 700, cursor: 'pointer',
                textAlign: 'center', boxSizing: 'border-box',
              }}>
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
              </button>
            </form>

            <button onClick={() => { setModoRecuperar(false); setMsgRecuperar(''); }} style={{
              background: 'none', border: 'none', color: '#0f6e56',
              fontSize: 13, cursor: 'pointer', marginTop: 16,
              width: '100%', textAlign: 'center',
            }}>
              ← Volver al login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
